module.exports = __webpack_public_path__ + "img/ESD-new-logo-a.8fbca2fc.png";